import { useEffect, useState } from "react";
import UIService from "../../../services/UIService";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    password: string;
};

export const PasswordRequirements = ({ password }: Props) => {
    const [requirements, setRequirements] = useState({
        length: false,
        lowercase: false,
        uppercase: false,
        number: false,
    });

    useEffect(() => {
        if (password) {
            setRequirements({
                length: password.length >= 8,
                lowercase: /[a-z]/.test(password),
                uppercase: /[A-Z]/.test(password),
                number: /[0-9]/.test(password),
            });
        } else {
            setRequirements({
                length: false,
                lowercase: false,
                uppercase: false,
                number: false,
            });
        }
    }, [password]);

    return (
        <div className="mt-4 mt-md-0">
            <OwTitle title={"requirements"} className={"mb-2"} tag={"h4"} />
            <ol className="list-disc list-inside space-y-1">
                <li className={UIService.combineClasses("text-sm", requirements.length ? "text-success" : "text-warning")}>
                    <OwLabel title={"minimum_eight_characters"} />
                </li>
                <li className={UIService.combineClasses("text-sm", requirements.lowercase ? "text-success" : "text-warning")}>
                    <OwLabel title={"at_least_one_lowercase_character"} />
                </li>
                <li className={UIService.combineClasses("text-sm", requirements.uppercase ? "text-success" : "text-warning")}>
                    <OwLabel title={"at_least_one_uppercase_character"} />
                </li>
                <li className={UIService.combineClasses("text-sm", requirements.number ? "text-success" : "text-warning")}>
                    <OwLabel title={"at_least_one_number"} />
                </li>
            </ol>
        </div>
    );
};
